import mainImage1 from "../lastimages/main/mainImage1.jpg";
import mainImage2 from "../lastimages/main/mainImage2.jpg";
import mainImage3 from "../lastimages/main/mainImage3.jpg";
import mainImage4 from "../lastimages/main/mainImage4.jpg";
import promotion_bg from "../lastimages/main/promotion_bg.jpg";
import whatDoyou1 from "../lastimages/main/whatDoyou1.png";
import whatDoyou2 from "../lastimages/main/whatDoyou2.png";
import whatDoyou3 from "../lastimages/main/whatDoyou3.png";
import whatDoyou4 from "../lastimages/main/whatDoyou4.png";
import whatDoyou5 from "../lastimages/main/whatDoyou5.png";
import ceylonProduct1 from "../lastimages/main/ceylonProduct1.png";
import ceylonProduct2 from "../lastimages/main/ceylonProduct2.png";
import ceylonProduct3 from "../lastimages/main/ceylonProduct3.png";
import ceylonProduct4 from "../lastimages/main/ceylonProduct4.png";
import member_bg from "../lastimages/main/member_bg.jpg";
import review1 from "../lastimages/main/review1.png";
import review2 from "../lastimages/main/review2.png";
import review3 from "../lastimages/main/review3.png";
import review4 from "../lastimages/main/review4.png";
import review5 from "../lastimages/main/review5.png";
import review6 from "../lastimages/main/review6.png";
import review7 from "../lastimages/main/review7.png";


export { mainImage1, mainImage2, mainImage3, mainImage4, promotion_bg, member_bg,
        whatDoyou1, whatDoyou2, whatDoyou3, whatDoyou4, whatDoyou5,
        ceylonProduct1, ceylonProduct2, ceylonProduct3, ceylonProduct4,
        review1, review2, review3, review4, review5, review6, review7 };


export default { mainImage1, mainImage2, mainImage3, mainImage4, promotion_bg, member_bg,
        whatDoyou1, whatDoyou2, whatDoyou3, whatDoyou4, whatDoyou5,
        ceylonProduct1, ceylonProduct2, ceylonProduct3, ceylonProduct4,
        review1, review2, review3, review4, review5, review6, review7 };
